import styles from "./TabTemplate.module.css";
import React from "react";
import classNames from "classnames";
function TabTemplate({ item, itemRender, onClickItem, getId, isDisabled: isDisabledCheck, selectedItem, classNameItem }) {
    var _a;
    const isActive = selectedItem ? getId(item) === getId(selectedItem) : false;
    const isDisabled = (_a = isDisabledCheck === null || isDisabledCheck === void 0 ? void 0 : isDisabledCheck(item)) !== null && _a !== void 0 ? _a : false;
    const onClick = onClickItem
        ? () => {
            if (!isDisabled) {
                onClickItem(item);
            }
        }
        : undefined;
    return (React.createElement("div", { className: classNames(styles.item, classNameItem), "data-active": isActive, "data-disabled": isDisabled, onClick: onClick }, itemRender({
        data: item,
        isActive,
        isDisabled
    })));
}
export default TabTemplate;
